export class SwContact {
    swcnId: number;
    swcnName: string;
    swcnEmail: string;
    swcnSubject: string;
    swcnMessage: string;
}
